export type GeographicPoint = readonly [longitude: number, latitude: number];
export type GeographicRing = readonly GeographicPoint[];

const GLOBE_CENTER = { latitude: 50, longitude: 8, x: 140, y: 110, radius: 96 };
const degreesToRadians = (value: number) => (value * Math.PI) / 180;

export interface GlobePoint {
  x: number;
  y: number;
  isVisible: boolean;
}

export function projectOnEuropeanGlobe(latitude: number, longitude: number): GlobePoint {
  const latitudeRadians = degreesToRadians(latitude);
  const longitudeDeltaRadians = degreesToRadians(longitude - GLOBE_CENTER.longitude);
  const centerLatitudeRadians = degreesToRadians(GLOBE_CENTER.latitude);
  const cosLatitude = Math.cos(latitudeRadians);
  const cosCenterLatitude = Math.cos(centerLatitudeRadians);
  const sinCenterLatitude = Math.sin(centerLatitudeRadians);

  return {
    x: GLOBE_CENTER.x + GLOBE_CENTER.radius * cosLatitude * Math.sin(longitudeDeltaRadians),
    y: GLOBE_CENTER.y - GLOBE_CENTER.radius * (cosCenterLatitude * Math.sin(latitudeRadians) - sinCenterLatitude * cosLatitude * Math.cos(longitudeDeltaRadians)),
    isVisible: sinCenterLatitude * Math.sin(latitudeRadians) + cosCenterLatitude * cosLatitude * Math.cos(longitudeDeltaRadians) >= 0,
  };
}

function toSvgPath(ring: GeographicRing): string {
  return ring.reduce<string>((path, [longitude, latitude], index) => {
    const point = projectOnEuropeanGlobe(latitude, longitude);
    if (!point.isVisible) return path;
    return `${path}${index === 0 || !path ? 'M' : 'L'}${point.x.toFixed(2)} ${point.y.toFixed(2)}`;
  }, '');
}

export function geographicRingsToPath(rings: readonly GeographicRing[]): string {
  return rings.map(toSvgPath).filter(Boolean).join(' ');
}

export function geographicLineToPath(points: readonly GeographicPoint[]): string {
  return toSvgPath(points);
}

export const coverageGlobe = GLOBE_CENTER;
